import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import App from './App';
import { ENV, validateEnvironment, logEnvironmentInfo } from './config/environment';

// Import global styles
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';// Validate environment configuration
validateEnvironment();

// Log environment info in development
if (ENV.IS_DEVELOPMENT) {
  logEnvironmentInfo();
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={ENV.TOAST_AUTO_CLOSE}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  </BrowserRouter>
  // </React.StrictMode>
);
